import { Block, Blocks } from '@chameleoncreator/creator-app';
import banner_primary_creator from 'assets/new_graphic_banner_default.png';
import graphic_header_logo from 'assets/chameleon_icon_white.svg';
import standard_header_logo from 'assets/Logo_updated.svg';
import { flatten } from 'factories/utils';
import { createBlock } from './block';

export type StandardHeader = {
  headerHeight: number;
  headerBackgroundColor: string;
  headerBackgroundOpacity: number;
  headerTextColor: string;
  backButton: boolean;
  topicName: boolean;
  progressBar: boolean;
  topicMenu: boolean;
  headerDropShadow: boolean;
};

export type GraphicHeader = {
  headerHeight: number;
  headerBackgroundColor: string;
  headerBackgroundOpacity: number;
  includeHeaderOverlay: boolean;
  headerOverlayColor: string;
  headerOverlayOpacity: number;
  headerTextColor: string;
  backButton: boolean;
  topicName: boolean;
  progressBar: boolean;
  topicMenu: boolean;
  headerDropShadow: boolean;
};

export const standardHeaderDefaults = {
  headerHeight: 70,
  headerBackgroundColor: '#ffffff',
  headerBackgroundOpacity: 100,
  headerTextColor: '#060709',
  backButton: true,
  topicName: true,
  progressBar: true,
  topicMenu: true,
  headerDropShadow: true,
};

export const graphicHeaderDefaults = {
  headerHeight: 170,
  headerBackgroundColor: '#ffffff',
  headerBackgroundOpacity: 100,
  includeHeaderOverlay: false,
  headerOverlayColor: '#000000',
  headerOverlayOpacity: 70,
  headerTextColor: '#ffffff',
  backButton: true,
  topicName: true,
  progressBar: true,
  topicMenu: true,
  headerDropShadow: false,
};

export const createHeader = (): Block => {
  return createBlock(
    'Header',
    [
      createBlock('StandardHeader', [
        createBlock('Logo', [], { props: { src: standard_header_logo } }),
      ]),
      createBlock('GraphicHeader', [
        createBlock('Background', [], {
          props: { src: banner_primary_creator },
        }),
        createBlock('Logo', [], { props: { src: graphic_header_logo } }),
      ]),
    ],
    {
      props: {},
    }
  );
};

export const addHeaders = (
  block: Block,
  props = {},
  logoProps = {}
): [Block, Blocks?] => {
  if (block.type === 'Header') {
    const headersBlock = createBlock('Headers', [
      createBlock(
        'StandardHeader',
        [
          createBlock('Logo', [], {
            props: {
              src: standard_header_logo,
              ...logoProps,
            },
          }),
        ],
        {
          props,
        }
      ),
      createBlock('GraphicHeader', [
        createBlock('Background', [], {
          props: { src: banner_primary_creator },
        }),
        createBlock('Logo', [], {
          props: {
            src: graphic_header_logo,
            ...logoProps,
          },
        }),
      ]),
    ]) as any;

    const headersBlockRef = {
      id: headersBlock.id,
      type: 'Ref',
    };

    const [newHeadersBlocks, rootId] = flatten(headersBlock);

    const nhb = newHeadersBlocks[rootId] as any;
    block.children = [...nhb.children];

    return [block, newHeadersBlocks];
  }
  return [block, undefined];
};
